import styled from 'styled-components';
import { BreakPoint } from '@makemydeal/dr-activities-common';

export const AICardWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    border: 1px solid #b2b2b2;
    padding: 8px;
    margin-bottom: 1rem;
`;

export const AICardLinksWrapper = styled.div<{ isCondensedLayout?: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${({ isCondensedLayout }) => (isCondensedLayout ? '8px' : '16px')};
    flex: 1;
    min-width: 0;

    ${({ isCondensedLayout }) =>
        isCondensedLayout &&
        `
        flex-wrap: wrap;

        > * {
            width: fit-content;
        }

        .ai-card-header {
            width: max-content;
        }
    `}
`;

export const Separator = styled.span`
    align-self: stretch;
    flex: 0 0 1px;
    background-color: #b2b2b2;

    @media (max-width: ${BreakPoint.SMALL}) {
        display: none;
    }
`;
